import { Divider, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Badge, Popover, Tooltip } from "@material-ui/core";
import React, { useState, useMemo } from "react";
import EventLabel2 from "../../../../components/EventLabel2/EventLabel2";
import { combineProps } from "../../../../helpers/objectHelper";
import { eventLabelGroupsConstants } from "../../../constants/eventLabelGroups.contansts";
import { ScrollWrapper } from "../../../helpers/module.helper";
import { ChatAvatar } from "./ChatAvatar";
import { ChatSearchbar } from "./ChatSearchbar";
import PersonRoundedIcon from "@material-ui/icons/PersonRounded";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import { NoResultState } from "./shared/NoResultState";
import { clientTypeConstants } from "../../../../interaction/constants/clientType.constants";
import { PersonInformationPopover } from "./shared/PersonInformationPopover";
import ReactEternalList from "../../../../components/ReactEternalList/ReactEternalList";

export function PeopleListPopover(props) {
  const [anchorEl, setAnchorEl] = useState(null);

  const { icon, tooltipText, chatTemplate, preview, children } = props;
  const { primaryColor } = chatTemplate;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "people-popover" : undefined;
  return (
    <div style={{ position: "relative" }}>
      <IconButton disabled={preview} aria-describedby={id} onClick={handleClick} style={{ color: primaryColor, padding: "8px" }}>
        <Tooltip title={<EventLabel2 name={"StartNewConversation"} groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />}>
          <AddRoundedIcon />
        </Tooltip>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="action-popover">
          <PeopleList {...combineProps([props, { handleClose }])} />
        </div>
      </Popover>
    </div>
  );
}

export function PeopleList(props) {
  const [filter, setFilter] = useState("");
  const { connectionList, orderList, channel, clientKey, settings, eventId } = props;
  const { showAllConnections } = settings;
  const clientList = useMemo(() => {
    if(showAllConnections) return connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_MEETING);
    return connectionList.filter((cl) => cl.type == clientTypeConstants.INTERACTION_MEETING && cl.eventId == eventId && cl.channel == channel);
  }, [channel, connectionList]);
  const activePeople = useMemo(() => {
    return orderList
      .filter((ia) => ia.badgeNo != clientKey && ia.orderId != 1 && ia.orderId != 2)
      .filter((ia) => {
        if (ia.anonymous == true) {
          return false;
        }
        if (!clientList.find((c) => c.clientKey == ia.badgeNo)) {
          return false;
        }
        if (ia.name.toLowerCase().includes(filter.toLowerCase())) {
          return true;
        }
        if (ia.company && ia.company.toLowerCase().includes(filter.toLowerCase())) {
          return true;
        }
        if (ia.title && ia.title.toLowerCase().includes(filter.toLowerCase())) {
          return true;
        }
        return false;
      })
      .sort((a, b) => {
        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      })
      .map((ia) => {
        let inSameRoom = clientList.some((c) => c.clientKey == ia.badgeNo && c.eventId == eventId);
        return { ...ia, inSameRoom };
      });
  }, [filter, orderList, clientList]);
  return (
    <div style={{ width: "100%", height: "100%", backgroundColor: "#fff" }}>
      <div
        style={{
          padding: "5px 10px",
          fontSize: "1rem",
          fontWeight: 600,
          fontFamily: "Arimo",
        }}
      >
        <EventLabel2 name="SearchForPeople" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />
      </div>
      <ChatSearchbar filter={setFilter} />
      <ScrollWrapper {...props}>
        <List className="jir-scroll" style={{ maxHeight: "calc(100vh - 130px)" }}>
          {activePeople.length > 0 ? (
            <ReactEternalList
              list={activePeople.map((o) => {
                return { ...props, person: o };
              })}
              updateRate={100}
              component={PersonListItem}
              compareParam={"badgeNo"}
            />
          ) : (
            <NoResultState />
          )}
        </List>
      </ScrollWrapper>
    </div>
  );
}

const PersonListItem = (props) => {
  const { selectChat, chatTemplate, clientKey, handleClose, person } = props;

  const { profileImage, linkedIn, title, name, company, badgeNo, inSameRoom } = person;

  return (
    <ListItem
      key={person.badgeNo}
      className="chat-list-item"
      style={{ cursor: clientKey == badgeNo ? "default" : "pointer", margin: "0px 5px" }}
      onClick={() => {
        if (clientKey == badgeNo) return;
        selectChat(badgeNo);
        handleClose();
      }}
    >
      <ListItemAvatar>
        <PersonInformationPopover
          {...combineProps([
            props,
            {
              target: badgeNo,
            },
          ])}
        >
          <ChatAvatar
            {...combineProps([
              props,
              chatTemplate,
              {
                target: badgeNo,
                hideOnlineBadge: true,
              },
            ])}
          >
            <PersonRoundedIcon />
          </ChatAvatar>
        </PersonInformationPopover>
      </ListItemAvatar>
      <ListItemText
        primary={
          <span className="ellipsis" style={{ fontWeight: "bold", fontFamily: "Arimo" }}>
            {name}
          </span>
        }
        secondary={
          <span>
            {title ? <span className="ellipsis">{title}</span> : null}
            {company ? (
              <span className="ellipsis">
                {title ? " • " : ""}
                {company}
              </span>
            ) : null}
            {/* {title ? `${title} • ${company}` : company} */}
            {!inSameRoom ? (
              <span className="in-another-room">
                {title || company ? " • " : ""}
                <EventLabel2 name="ActiveInAnotherRoom" groupName={eventLabelGroupsConstants.CHAT_LABEL_GROUP} />
              </span>
            ) : null}
          </span>
        }
      />
    </ListItem>
  );
};
